import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {

    constructor(private router: Router){}

    hasUrlSeg = (seg: string) => (this.router.url.split('?')[0]).indexOf(seg) !== -1;

    digestFrequencies = [
        { viewValue: 'Hourly', value: 'HOURLY'},
        { viewValue: 'Daily', value: 'DAILY'},
        { viewValue: 'Weekly', value: 'WEEKLY'},
        { viewValue: 'Monthly', value: 'MONTHLY'}
    ];

    zoneMap = {
        'Pacific/Pago_Pago': 'US/Samoa',
        'Pacific/Honolulu': 'US/Hawaii',
        'America/Anchorage': 'US/Alaska',
        'America/Los_Angeles': 'US/Pacific',
        'America/Denver': 'US/Mountain',
        'America/Chicago': 'US/Central',
        'America/New_York': 'US/Eastern',
        'America/Halifax': 'Canada/Atlantic',
        'America/St_Johns': 'Canada/Newfoundland',
        'America/Noronha': 'Brazil/DeNoronha'
    };

    displayTimezones = [
        { value: 'US/Samoa', viewValue: 'Midway Island, Samoa'},
        { value: 'US/Hawaii', viewValue: 'Hawaii'},
        { value: 'US/Alaska', viewValue: 'Alaska'},
        { value: 'US/Pacific', viewValue: 'Pacific Time (US & Canada)'},
        { value: 'US/Mountain', viewValue: 'Mountain Time (US & Canada)'},
        { value: 'US/Central', viewValue: 'Central Time (US & Canada), Mexico City'},
        { value: 'US/Eastern', viewValue: 'Eastern Time (US & Canada), Bogota, Lima'},
        { value: 'Canada/Atlantic', viewValue: 'Atlantic Time (Canada), Caracas, La Paz'},
        { value: 'Canada/Newfoundland', viewValue: 'Newfoundland'},
        { value: 'America/Argentina/Buenos_Aires', viewValue: 'Brazil, Buenos Aires, Georgetown'},
        { value: 'Brazil/DeNoronha', viewValue: 'Mid-Atlantic'},
        { value: 'Atlantic/Cape_Verde', viewValue: 'Azores, Cape Verde Islands'},
        { value: 'Europe/London', viewValue: 'Western Europe Time, London, Lisbon, Casablanca'},
        { value: 'Europe/Paris', viewValue: 'Brussels, Copenhagen, Madrid, Paris'},
        { value: 'Europe/Kaliningrad', viewValue: 'Kaliningrad, South Africa'},
        { value: 'Europe/Moscow', viewValue: 'Baghdad, Riyadh, Moscow, St. Petersburg'},
        { value: 'Europe/Samara', viewValue: 'Abu Dhabi, Muscat, Baku, Tbilisi'},
        { value: 'Asia/Kabul', viewValue: 'Kabul'},
        { value: 'Asia/Karachi', viewValue: 'Ekaterinburg, Islamabad, Karachi, Tashkent'},
        { value: 'Asia/Colombo', viewValue: 'Bombay, Calcutta, Madras, New Delhi'},
        { value: 'Asia/Kathmandu', viewValue: 'Kathmandu'},
        { value: 'Asia/Almaty', viewValue: 'Almaty, Dhaka, Colombo'},
        { value: 'Asia/Bangkok', viewValue: 'Bangkok, Hanoi, Jakarta'},
        { value: 'Asia/Hong_Kong', viewValue: 'Beijing, Perth, Singapore, Hong Kong'},
        { value: 'Asia/Tokyo', viewValue: 'Tokyo, Seoul, Osaka, Sapporo, Yakutsk'},
        { value: 'Australia/Darwin', viewValue: 'Adelaide, Darwin'},
        { value: 'Pacific/Guam', viewValue: 'Eastern Australia, Guam, Vladivostok'},
        { value: 'Pacific/Noumea', viewValue: 'Magadan, Solomon Islands, New Caledonia'},
        { value: 'Pacific/Majuro', viewValue: 'Auckland, Wellington, Fiji, Kamchatka'}
    ];

    cleanQuotes = target =>  target ? target.replace(/[\u2018\u2019]/g, '\'').replace(/[\u201C\u201D]/g, '"') : target;
}
